import React, { useCallback, useEffect, useState } from 'react';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { CommercialPage } from './pages/CommercialPage';
import { ServicesPage } from './pages/ServicesPage';
import { ResidentialPage } from './pages/ResidentialPage';
import { ReservationPage } from './pages/ReservationPage';
import { CinemaPage } from './pages/CinemaPage';
type PageType = 'home' | 'commercial' | 'services' | 'residential' | 'reservation' | 'cinema';
export function App() {
  const [currentPage, setCurrentPage] = useState<PageType>('home');
  const [activeSection, setActiveSection] = useState<string | null>('hero');
  const handleNavigate = (page: PageType) => {
    setCurrentPage(page);
    setActiveSection(page === 'home' ? 'hero' : null);
    window.scrollTo(0, 0);
  };
  const handleScroll = useCallback(() => {
    if (currentPage !== 'home') return;
    const sections = ['kontakt', 'onas', 'hero'];
    for (const id of sections) {
      const el = document.getElementById(id);
      if (el) {
        const rect = el.getBoundingClientRect();
        if (rect.top <= 200) {
          setActiveSection(id);
          return;
        }
      }
    }
    setActiveSection('hero');
  }, [currentPage]);
  useEffect(() => {
    if (currentPage === 'home') {
      window.addEventListener('scroll', handleScroll, {
        passive: true
      });
      handleScroll();
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [currentPage, handleScroll]);
  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage onNavigate={handleNavigate} data-id="element-0" />;
      case 'commercial':
        return <CommercialPage onNavigate={handleNavigate} data-id="element-1" />;
      case 'services':
        return <ServicesPage data-id="element-2" />;
      case 'residential':
        return <ResidentialPage onNavigate={handleNavigate} data-id="element-3" />;
      case 'reservation':
        return <ReservationPage data-id="element-4" />;
      case 'cinema':
        return <CinemaPage data-id="element-5" />;
      default:
        return <HomePage onNavigate={handleNavigate} data-id="element-6" />;
    }
  };
  return <div className="min-h-screen w-full bg-white" data-id="element-7">
      <Header currentPage={currentPage} onNavigate={handleNavigate} activeSection={currentPage === 'home' ? activeSection : undefined} data-id="element-8" />
      {renderPage()}
      <Footer data-id="element-9" />
    </div>;
}